/*
 * Hand-off of the email typed on the home page to the registration form. The address never
 * goes in the URL (it would end up in logs, history and analytics); it waits in
 * sessionStorage until /register reads it once and clears it.
 */

export const SIGNUP_EMAIL_KEY = 'cleancal_signup_email';

const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Loose shape check (something@domain.tld); the registration form does the real validation. */
export function looksLikeEmail(value: string): boolean {
  return value.length <= 254 && EMAIL_SHAPE.test(value);
}

/** Keeps `email` for the registration form. Storage can be unavailable (private mode, blocked). */
export function storeSignupEmail(email: string): void {
  try {
    window.sessionStorage.setItem(SIGNUP_EMAIL_KEY, email);
  } catch {
    // No prefill then; the form still works.
  }
}

/** Removes any stored address, e.g. when the visitor submits an empty or invalid one. */
export function clearSignupEmail(): void {
  try {
    window.sessionStorage.removeItem(SIGNUP_EMAIL_KEY);
  } catch {
    // Nothing to clear.
  }
}

/** Reads the stored address once and clears it. Returns null when there is none. */
export function takeSignupEmail(): string | null {
  try {
    const value = window.sessionStorage.getItem(SIGNUP_EMAIL_KEY);
    window.sessionStorage.removeItem(SIGNUP_EMAIL_KEY);
    return value && looksLikeEmail(value) ? value : null;
  } catch {
    return null;
  }
}
